import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    createNewProject: string;
    defaultProjectName: string;
    editAvatar: string;
    unableToRedirect: string;
    dialogCloseLabel: string;
    selectWorkspaceTooltip: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Dialog title and primary action label for creating a project */
            createNewProject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CreateProjectModal.createNewProject?c=1oiqzouofct2u", defaultMessage: "Create New Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Default project name when none is provided */
            defaultProjectName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CreateProjectModal.defaultProjectName?c=3lwyyx94sr8g7", defaultMessage: "Untitled Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the avatar editor action */
            editAvatar: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CreateProjectModal.editAvatar?c=m32wpmcnpvan", defaultMessage: "Edit project avatar" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when redirect to new project fails */
            unableToRedirect: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CreateProjectModal.unableToRedirect?c=1peik84hmikru", defaultMessage: "Can''t redirect to project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the dialog close button */
            dialogCloseLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CreateProjectModal.dialogCloseLabel?c=2g2kiprif3vje", defaultMessage: "Close Dialog" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip shown on the disabled Create button when no workspace is selected */
            selectWorkspaceTooltip: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CreateProjectModal.selectWorkspaceTooltip?c=16ovhx773zlhx", defaultMessage: "Select a workspace to create this project" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
